var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mars-view',{staticClass:"tag-item c-font-normal c-line-clamp1",style:({
    borderRadius: _vm.borderRadius,
    color: _vm.selected
        ? _vm.primaryColor
            ? _vm.primaryColor
            : '#5183FF'
        : _vm.color,
    backgroundColor: _vm.selected
        ? _vm.backgroundColorSelected
            ? _vm.backgroundColorSelected
            : '#f5f9ff'
        : _vm.backgroundColor,
    border: _vm.selected
        ? '1px solid ' + _vm.primaryColor
        : '',
    padding: _vm.selected
        ? '6px 4px'
        : '7px 5px',
    fontWeight: _vm.selected && _vm.selectedBold ? 'bold' : 'normal'
})},[_c('mars-view',{staticClass:"c-line-clamp1"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n")]),(_vm.selectedIcon)?_c('c-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.selected),expression:"selected"}],staticClass:"c-gap-left-small",attrs:{"name":"check"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }